import RelatedProduct from "./RelatedProduct";
export default RelatedProduct;
